export default [
    {
        path: 'relatorio-alto-custo-retirada-pendente',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-alto-custo-retirada-pendente' */
            '@/views/farmacia/relatorio-alto-custo-retirada-pendente/Index'
        ),
        redirect: 'relatorio-alto-custo-retirada-pendente/index',
        children: [
            {
                name: 'farmacia-relatorio-alto-custo-retirada-pendente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-alto-custo-retirada-pendente' */
                    '@/views/farmacia/relatorio-alto-custo-retirada-pendente/List.vue'
                ),
            },
        ],
    },
]